import React from 'react';
import { useParams } from 'react-router';

import { useQuestionnaireSection, useQuestionnaireSections } from '@/features/constructor/hooks';
import { Section } from '@/features/constructorCommon';

export const QuestionnaireSection = ({sectionProp, onCreated, ...props}) => {
  const { id } = useParams();
  const {
    handleCreate,
    handleUpdate,
    handleDelete,
    isCreating,
    isUpdating,
    isDeleting
  } = useQuestionnaireSection({questionSectionTypeId: id});
  const { dataSorted, loading, answers, setAnswers } = useQuestionnaireSections(
    id,
    sectionProp ? sectionProp.visibleConditions : null
  );
  return (
    <Section sectionProp={sectionProp}
             onCreated={onCreated}
             handleCreate={handleCreate}
             handleUpdate={handleUpdate}
             handleDelete={handleDelete}
             isCreating={isCreating}
             isUpdating={isUpdating}
             isDeleting={isDeleting}
             dataSortedSections={dataSorted}
             loadingSections={loading}
             dependentAnswers={answers}
             setDependentAnswers={setAnswers}
             type="questionnaire"
             {...props}
    />
  );
};
